import { Component, Input } from '@angular/core';
import { ColumnDef } from '../../../reports/dtos/interfaces/column-def';
import { ReportState } from '../../../reports/dtos/enums/report-state';

@Component({
    selector: 'app-report-table',
    template: require('./report-table.component.html'),
    styles: [ require('./report-table.component.css') ],
})
export class ReportTableComponent {
    states = ReportState;
    @Input() columns: ColumnDef[] = [];
    @Input() rows: any[] = [];
    @Input() totalRows: number;
    @Input() state: ReportState = ReportState.None;
    @Input() emptyMessage = 'No records';
    @Input() showHeader: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/reports/report-table/report-table.component.ts